import React from 'react';
import './index.css';

export const NotFoundIcon = (props) => {
  const scrSet = (!!props.img2x && `${require(`./img/${props.img2x}`)} 2x`);
  return <img className="img-404" src={ require(`./img/${props.img}`) } srcSet={scrSet === 0 ? false : scrSet} alt="" />
};

export default ({children}) => children;
